import { request } from "@/api/server/index";

export default {
  //V025_日報登録・確認画面
  DailyReportEdit: {
    // 初期表示
    indexDailyReportEdit(params) {
      return request({
        url: "/dailyReportEdit/indexDailyReportEdit",
        data: params,
        method: "post"
      });
    },
    // 検索
    searchDailyReportEditList(params) {
      return request({
        url: "/dailyReportEdit/searchDailyReportEditList",
        data: params,
        method: "post"
      });
    },
    // 編集
    updateDailyReportEdit(params) {
      return request({
        url: "/dailyReportEdit/updateDailyReportEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V026_日報検索・コメント入力画面
  DailyReportComment: {
    // 初期表示
    indexDailyReportComment(params) {
      return request({
        url: "/dailyReportComment/indexDailyReportComment",
        data: params,
        method: "post"
      });
    },
    // 出先を変更
    changeBranchKey(params) {
      return request({
        url: "/dailyReportComment/changeBranchKey",
        data: params,
        method: "post"
      });
    },
    // ユーザのリストを更新します
    searchUserList(params) {
      return request({
        url: "/dailyReportComment/searchUserList",
        data: params,
        method: "post"
      });
    },
    // 検索
    searchDailyReportCommentList(params) {
      return request({
        url: "/dailyReportComment/searchDailyReportCommentList",
        data: params,
        method: "post"
      });
    },
    // 編集
    updateDailyReportComment(params) {
      return request({
        url: "/dailyReportComment/updateDailyReportComment",
        data: params,
        method: "post"
      });
    }
  },
  // V041_成績見込み集計画面
  PerformanceSummaryReport: {
    // 初期表示
    indexPerformanceSummaryReport(params) {
      return request({
        url: "/performanceSummaryReport/indexPerformanceSummaryReport",
        data: params,
        method: "post"
      });
    },
    // 集計単位②リスト更新
    searchTotalItemSelect2List(params) {
      return request({
        url: "/performanceSummaryReport/searchTotalItemSelect2List",
        data: params,
        method: "post"
      });
    },
    // 集計単位③データ更新
    searchTotalItemSelect3List(params) {
      return request({
        url: "/performanceSummaryReport/searchTotalItemSelect3List",
        data: params,
        method: "post"
      });
    },
    // 部署リスト更新
    searchDepartmentList(params) {
      return request({
        url: "/performanceSummaryReport/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // 集計
    searchPerformanceSummaryReportList(params) {
      return request({
        url: "/performanceSummaryReport/searchPerformanceSummaryReportList",
        data: params,
        method: "post"
      });
    }
  },
  // V042_成約一覧・集計表作成
  SignedContractSummaryReport: {
    // 初期表示
    indexSignedContractSummaryReport(params) {
      return request({
        url: "/signedContractSummaryReport/indexSignedContractSummaryReport",
        data: params,
        method: "post"
      });
    },
    // 部署リスト更新
    searchDepartmentList(params) {
      return request({
        url: "/signedContractSummaryReport/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // 成約集計帳票作成 作成
    downloadSignedContractSummaryReport(params) {
      return request({
        url: "/signedContractSummaryReport/downloadSignedContractSummaryReport",
        data: params,
        method: "post",
        responseType: "blob"
      });
    },
    // 件数チェック
    searchSignedContractSummaryReportCount(params) {
      return request({
        url: "/signedContractSummaryReport/searchSignedContractSummaryReportCount",
        data: params,
        method: "post"
      });
    }
  },
  // V043_接点集計表画面
  ContactSummaryReport: {
    // 初期表示
    indexContactSummaryReport(params) {
      return request({
        url: "/contactSummaryReport/indexContactSummaryReport",
        data: params,
        method: "post"
      });
    },
    // 集計
    searchContactSummaryReportList(params) {
      return request({
        url: "/contactSummaryReport/searchContactSummaryReportList",
        data: params,
        method: "post"
      });
    }
  },
  // V044_解約集計表画面
  CancelSummaryReport: {
    // 初期表示
    indexCancelSummaryReport(params) {
      return request({
        url: "/cancelSummaryReport/indexCancelSummaryReport",
        data: params,
        method: "post"
      });
    },
    // 集計
    searchCancelSummaryReportList(params) {
      return request({
        url: "/cancelSummaryReport/searchCancelSummaryReportList",
        data: params,
        method: "post"
      });
    }
  },
  // V045_苦情等集計表画面
  ClaimSummaryReport: {
    // 初期表示
    indexClaimSummaryReport(params) {
      return request({
        url: "/claimSummaryReport/indexClaimSummaryReport",
        data: params,
        method: "post"
      });
    },
    // 集計
    searchClaimSummaryReportList(params) {
      return request({
        url: "/claimSummaryReport/searchClaimSummaryReportList",
        data: params,
        method: "post"
      });
    }
  },
  //V091_パフォーマンス管理表
  PerformanceManagementReport: {
    //初期表示
    indexPerformanceManagementReport(params) {
      return request({
        url: "/performanceManagementReport/indexPerformanceManagementReport",
        data: params,
        method: "post"
      });
    },
    //営業担当者リスト取得
    searchUserList(params) {
      return request({
        url: "/performanceManagementReport/searchUserList",
        data: params,
        method: "post"
      });
    },
    // 成約集計帳票作成 作成
    outputExcel(params) {
      return request({
        url: "/performanceManagementReport/outputExcel",
        data: params,
        method: "post",
        responseType: "blob"
      });
    }
  }
};
